import {Box, TextField} from "@mui/material";
import {observer} from 'mobx-react';
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import FormSection from "../../../forms/FormSection";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import {BACKOFFICE_USERS_PATH} from "../../../routes";
import {useNavigatorFeature} from "../../../useFeature";
import {useApplication} from "../../../ApplicationProvider";
import FormAutocompleteMultipleSelectField from "../../../components/fields/FormAutocompleteMultipleSelectField";
import AssignPermissionsFeature from "./AssignPermissionsFeature";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import FilledButton from "../../../components/buttons/FilledButton";
import Typography from "@mui/material/Typography";
import PermissionGroupSection from "./PermissionGroupSection";


function AssignPermissionsScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const {id} = useParams();
    const feature = useNavigatorFeature(() => new AssignPermissionsFeature(application, navigator, id), navigator, [id])

    const styles = {
        permissionSearch: {
            marginBottom: '1rem',
        },
        permissionGroupsGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '1rem',
        }
    };

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const currentAccountContent = () => {
        return isFeatureReady(feature) && (
            <div>
                <LayoutContentToolbar
                    title={`Usuario ${feature.userEmail()}`}
                    breadcrumbs={[
                        {label: 'Usuarios Backoffice', path: BACKOFFICE_USERS_PATH},
                        {label: `Usuario ${feature.userEmail()}`},
                    ]}
                />
                <FormSection
                    header={
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h3" sx={{ fontSize: '1rem', margin: '.8em 0' }}>
                                Grupos de Clientes
                            </Typography>
                            <FilledButton onClick={() => feature.selectAllCustomerGroups()}>
                                <GroupAddIcon fontSize="small" />
                                Seleccionar todos
                            </FilledButton>
                        </Box>
                    }
                >
                    <FormAutocompleteMultipleSelectField
                        label={'Clientes asignados'}
                        form={feature.form}
                        fieldName={'customerGroups'}
                        options={feature.customerGroupFieldOptions()}
                    />
                </FormSection>

                <FormSection title="Permisos">
                    <TextField label={'Buscar permiso'} fullWidth sx={styles.permissionSearch} value={feature.permissionSearchText} onChange={(event) => feature.searchPermissions(event.target.value)}/>
                    <Box sx={styles.permissionGroupsGrid}>
                        {feature.permissionGroups.map(permissionGroup => (
                            <PermissionGroupSection
                                key={permissionGroup.name}
                                permissionGroup={permissionGroup}
                                form={feature.form}
                                fieldName={'permissions'}
                                matchesPermissionSearch={(permission) => feature.matchesPermissionSearch(permission)}
                            />
                        ))}
                    </Box>
                </FormSection>
            </div>
        )
    }
    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => currentAccountContent()}/>
    );
}

export default observer(AssignPermissionsScreen);
